"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgCreateTicket = function SvgCreateTicket(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 5h1v4h-1zm-2-1h5v1h-5z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#007AFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.4 4h1v6h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6.4v1H0v-1z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#007AFF",
    d: "M21.867 1C22.493 1 23 1.474 23 2.06v9.98c0 .774-.672 1.403-1.501 1.403-.33 0-.65-.102-.912-.289l-1.69-1.209a1.195 1.195 0 0 0-1.42.032L15.23 13.75a1.194 1.194 0 0 1-1.46.002l-2.262-1.777a1.195 1.195 0 0 0-1.419-.029l-1.683 1.208c-.655.47-1.593.355-2.096-.258a1.34 1.34 0 0 1-.309-.85V11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#007AFF",
    d: "M6 3v-.94C6 1.474 6.507 1 7.133 1H22"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgCreateTicket);
var _default = exports["default"] = Memo;